export const accountPermissions = {
  VIEW_PENALTY: 'VIEW_PENALTY',
  CREATE_PENALTY: 'CREATE_PENALTY',
  MODIFY_PENALTY: 'MODIFY_PENALTY',
  ACTIVATE_PENALTY: 'ACTIVATE_PENALTY',
  DEACTIVATE_PENALTY: 'DEACTIVATE_PENALTY',
  DISBURSE_LOAN: 'DISBURSE_LOAN',
  VIEW_BATCH_LOAN_DISBURSE: 'VIEW_BATCH_LOAN_DISBURSE',
  BATCH_LOAN_DISBURSE: 'BATCH_LOAN_DISBURSE',
  REPAY_LOAN: 'REPAY_LOAN',
  CREATE_LIEN: 'CREATE_LIEN',
  MODIFY_LIEN: 'MODIFY_LIEN',
  ACTIVATE_LIEN: 'ACTIVATE_LIEN',
  DEACTIVATE_LIEN: 'DEACTIVATE_LIEN',
  VIEW_LIEN: 'VIEW_LIEN',
  CREATE_SAVING_CURRENT_ACCOUNT: 'CREATE_SAVING_CURRENT_ACCOUNT',
  MODIFY_SAVING_CURRENT_ACCOUNT: 'MODIFY_SAVING_CURRENT_ACCOUNT',
  ACTIVATE_SAVING_CURRENT_ACCOUNT: 'ACTIVATE_SAVING_CURRENT_ACCOUNT',
  DEACTIVATE_SAVING_CURRENT_ACCOUNT: 'DEACTIVATE_SAVING_CURRENT_ACCOUNT',
  VIEW_SAVING_CURRENT_ACCOUNT: 'VIEW_SAVING_CURRENT_ACCOUNT',
  VIEW_CUSTOMER_ACCOUNT_BALANCE: 'VIEW_CUSTOMER_ACCOUNT_BALANCE',
  CLOSE_CUSTOMER_ACCOUNT: 'CLOSE_CUSTOMER_ACCOUNT',
  VIEW_CLOSED_ACCOUNTS: 'VIEW_CLOSED_ACCOUNTS',
  CREATE_LOAN_ACCOUNT: 'CREATE_LOAN_ACCOUNT',
  MODIFY_LOAN_ACCOUNT: 'MODIFY_LOAN_ACCOUNT',
  VIEW_LOAN_ACCOUNT: 'VIEW_LOAN_ACCOUNT',
  RELEASE_SECURITY_DEPOSIT: 'RELEASE_SECURITY_DEPOSIT',
  CREATE_FIXED_DEPOSIT_ACCOUNT: 'CREATE_FIXED_DEPOSIT_ACCOUNT',
  MODIFY_FIXED_DEPOSIT_ACCOUNT: 'MODIFY_FIXED_DEPOSIT_ACCOUNT',
  LIQUIDATE_FIXED_DEPOSIT_ACCOUNT: 'LIQUIDATE_FIXED_DEPOSIT_ACCOUNT',
  FIXED_DEPOSIT_TOP_UP: 'FIXED_DEPOSIT_TOP_UP',
  VIEW_FIXED_DEPOSIT_ACCOUNT: 'VIEW_FIXED_DEPOSIT_ACCOUNT',
  CREATE_OVERDRAFT: 'CREATE_OVERDRAFT',
  MODIFY_OVERDRAFT: 'MODIFY_OVERDRAFT',
  VIEW_OVERDRAFT: 'VIEW_OVERDRAFT',
  ACTIVATE_OVERDRAFT: 'ACTIVATE_OVERDRAFT',
  DEACTIVATE_OVERDRAFT: 'DEACTIVATE_OVERDRAFT',
  CREATE_GENERAL_LEDGER: 'CREATE_GENERAL_LEDGER',
  MODIFY_GENERAL_LEDGER: 'MODIFY_GENERAL_LEDGER',
  VIEW_GENERAL_LEDGER: 'VIEW_GENERAL_LEDGER',
  ACTIVATE_GENERAL_LEDGER: 'ACTIVATE_GENERAL_LEDGER',
  DEACTIVATE_GENERAL_LEDGER: 'DEACTIVATE_GENERAL_LEDGER',
  CREATE_COT_FEE: 'CREATE_COT_FEE',
  MODIFY_COT_FEE: 'MODIFY_COT_FEE',
  VIEW_COT_FEE: 'VIEW_COT_FEE',
  ACTIVATE_COT_FEE: 'ACTIVATE_COT_FEE',
  DEACTIVATE_COT_FEE: 'DEACTIVATE_COT_FEE',
  CREATE_OVERDRAFT_FEE: 'CREATE_OVERDRAFT_FEE',
  MODIFY_OVERDRAFT_FEE: 'MODIFY_OVERDRAFT_FEE',
  VIEW_OVERDRAFT_FEE: 'VIEW_OVERDRAFT_FEE',
  ACTIVATE_OVERDRAFT_FEE: 'ACTIVATE_OVERDRAFT_FEE',
  DEACTIVATE_OVERDRAFT_FEE: 'DEACTIVATE_OVERDRAFT_FEE',
  CREATE_LOAN_FEE: 'CREATE_LOAN_FEE',
  MODIFY_LOAN_FEE: 'MODIFY_LOAN_FEE',
  VIEW_LOAN_FEE: 'VIEW_LOAN_FEE',
  ACTIVATE_LOAN_FEE: 'ACTIVATE_LOAN_FEE',
  DEACTIVATE_LOAN_FEE: 'DEACTIVATE_LOAN_FEE',
  CREATE_INTEREST: 'CREATE_INTEREST',
  MODIFY_INTEREST: 'MODIFY_INTEREST',
  VIEW_INTEREST: 'VIEW_INTEREST',
  ACTIVATE_INTEREST: 'ACTIVATE_INTEREST',
  DEACTIVATE_INTEREST: 'DEACTIVATE_INTEREST',
  CREATE_CHARGE: 'CREATE_CHARGE',
  MODIFY_CHARGE: 'MODIFY_CHARGE',
  VIEW_CHARGE: 'VIEW_CHARGE',
  ACTIVATE_CHARGE: 'ACTIVATE_CHARGE',
  DEACTIVATE_CHARGE: 'DEACTIVATE_CHARGE',
  CREATE_INDIVIDUAL_CUSTOMER: 'CREATE_INDIVIDUAL_CUSTOMER',
  MODIFY_INDIVIDUAL_CUSTOMER: 'MODIFY_INDIVIDUAL_CUSTOMER',
  VIEW_INDIVIDUAL_CUSTOMER: 'VIEW_INDIVIDUAL_CUSTOMER',
  ACTIVATE_INDIVIDUAL_CUSTOMER: 'ACTIVATE_INDIVIDUAL_CUSTOMER',
  DEACTIVATE_INDIVIDUAL_CUSTOMER: 'DEACTIVATE_INDIVIDUAL_CUSTOMER',
  CREATE_GROUP_CUSTOMER: 'CREATE_GROUP_CUSTOMER',
  MODIFY_GROUP_CUSTOMER: 'MODIFY_GROUP_CUSTOMER',
  VIEW_GROUP_CUSTOMER: 'VIEW_GROUP_CUSTOMER',
  ACTIVATE_GROUP_CUSTOMER: 'ACTIVATE_GROUP_CUSTOMER',
  DEACTIVATE_GROUP_CUSTOMER: 'DEACTIVATE_GROUP_CUSTOMER',
  CREATE_CORPORATE_CUSTOMER: 'CREATE_CORPORATE_CUSTOMER',
  MODIFY_CORPORATE_CUSTOMER: 'MODIFY_CORPORATE_CUSTOMER',
  VIEW_CORPORATE_CUSTOMER: 'VIEW_CORPORATE_CUSTOMER',
  ACTIVATE_CORPORATE_CUSTOMER: 'ACTIVATE_CORPORATE_CUSTOMER',
  DEACTIVATE_CORPORATE_CUSTOMER: 'DEACTIVATE_CORPORATE_CUSTOMER',
  CREATE_SAVING_CURRENT_PRODUCT: 'CREATE_SAVING_CURRENT_PRODUCT',
  MODIFY_SAVING_CURRENT_PRODUCT: 'MODIFY_SAVING_CURRENT_PRODUCT',
  VIEW_SAVING_CURRENT_PRODUCT: 'VIEW_SAVING_CURRENT_PRODUCT',
  ACTIVATE_SAVING_CURRENT_PRODUCT: 'ACTIVATE_SAVING_CURRENT_PRODUCT',
  DEACTIVATE_SAVING_CURRENT_PRODUCT: 'DEACTIVATE_SAVING_CURRENT_PRODUCT',
  CREATE_LOAN_PRODUCT: 'CREATE_LOAN_PRODUCT',
  MODIFY_LOAN_PRODUCT: 'MODIFY_LOAN_PRODUCT',
  VIEW_LOAN_PRODUCT: 'VIEW_LOAN_PRODUCT',
  ACTIVATE_LOAN_PRODUCT: 'ACTIVATE_LOAN_PRODUCT',
  DEACTIVATE_LOAN_PRODUCT: 'DEACTIVATE_LOAN_PRODUCT',
  CREATE_FIXED_DEPOSIT_PRODUCT: 'CREATE_FIXED_DEPOSIT_PRODUCT',
  MODIFY_FIXED_DEPOSIT_PRODUCT: 'MODIFY_FIXED_DEPOSIT_PRODUCT',
  VIEW_FIXED_DEPOSIT_PRODUCT: 'VIEW_FIXED_DEPOSIT_PRODUCT',
  ACTIVATE_FIXED_DEPOSIT_PRODUCT: 'ACTIVATE_FIXED_DEPOSIT_PRODUCT',
  DEACTIVATE_FIXED_DEPOSIT_PRODUCT: 'DEACTIVATE_FIXED_DEPOSIT_PRODUCT',
  CREATE_ACCOUNT_OFFICER: 'CREATE_ACCOUNT_OFFICER',
  MODIFY_ACCOUNT_OFFICER: 'MODIFY_ACCOUNT_OFFICER',
  VIEW_ACCOUNT_OFFICER: 'VIEW_ACCOUNT_OFFICER',
  ACTIVATE_ACCOUNT_OFFICER: 'ACTIVATE_ACCOUNT_OFFICER',
  DEACTIVATE_ACCOUNT_OFFICER: 'DEACTIVATE_ACCOUNT_OFFICER',
  UNLINK_ACCOUNT_OFFICER: 'UNLINK_ACCOUNT_OFFICER',
  CREATE_ACCOUNT_CATEGORY: 'CREATE_ACCOUNT_CATEGORY',
  MODIFY_ACCOUNT_CATEGORY: 'MODIFY_ACCOUNT_CATEGORY',
  VIEW_ACCOUNT_CATEGORY: 'VIEW_ACCOUNT_CATEGORY',
  ACTIVATE_ACCOUNT_CATEGORY: 'ACTIVATE_ACCOUNT_CATEGORY',
  DEACTIVATE_ACCOUNT_CATEGORY: 'DEACTIVATE_ACCOUNT_CATEGORY',
  CREATE_FIXED_ASSET: 'CREATE_FIXED_ASSET',
  MODIFY_FIXED_ASSET: 'MODIFY_FIXED_ASSET',
  VIEW_FIXED_ASSET: 'VIEW_FIXED_ASSET',
  ACTIVATE_FIXED_ASSET: 'ACTIVATE_FIXED_ASSET',
  DEACTIVATE_FIXED_ASSET: 'DEACTIVATE_FIXED_ASSET',
  LIQUIDATE_FIXED_ASSET: 'LIQUIDATE_FIXED_ASSET',
  ACTIVATE_PREPAYMENT_AMORTIZATION: 'ACTIVATE_PREPAYMENT_AMORTIZATION',
  CREATE_PREPAYMENT_AMORTIZATION: 'CREATE_PREPAYMENT_AMORTIZATION',
  DEACTIVATE_PREPAYMENT_AMORTIZATION: 'DEACTIVATE_PREPAYMENT_AMORTIZATION',
  LIQUIDATE_PREPAYMENT_AMORTIZATION: 'LIQUIDATE_PREPAYMENT_AMORTIZATION',
  MODIFY_PREPAYMENT_AMORTIZATION: 'MODIFY_PREPAYMENT_AMORTIZATION',
  VIEW_PREPAYMENT_AMORTIZATION: 'VIEW_PREPAYMENT_AMORTIZATION',
  ADD_PLACEMENT: 'ADD_PLACEMENT',
  UPDATE_PLACEMENT: 'UPDATE_PLACEMENT',
  VIEW_PLACEMENT: 'VIEW_PLACEMENT',
  VIEW_LOAN_PROVISIONING: 'VIEW_LOAN_PROVISIONING',
  VIEW_OVERDRAFT_PROVISIONING: 'VIEW_OVERDRAFT_PROVISIONING',
  ACCOUNT_STATEMENT: 'ACCOUNT_STATEMENT',
  ABRIDGED_LOAN: 'ABRIDGED_LOAN',
  VIEW_ABRIDGED_LOAN: 'VIEW_ABRIDGED_LOAN',
  EXPORT_FIXED_DEPOSIT_CERTIFICATE: 'EXPORT_FIXED_DEPOSIT_CERTIFICATE',
  VALIDATE_BVN: 'VALIDATE_BVN',
  VALIDATE_NIN: 'VALIDATE_NIN',
  VALIDATE_TIN: 'VALIDATE_TIN',
  RESTRUCTURE_LOAN: 'RESTRUCTURE_LOAN',
  REFINANCE_LOAN: 'REFINANCE_LOAN',
  CREATE_VIRTUAL_ACCOUNT: 'CREATE_VIRTUAL_ACCOUNT',
  ACCOUNT_OFFICER_REASSIGNMENT: 'ACCOUNT_OFFICER_REASSIGNMENT',
  BATCH_ACCOUNT_OFFICER_REASSIGNMENT: 'BATCH_ACCOUNT_OFFICER_REASSIGNMENT',
  ADD_MEMO: 'ADD_MEMO',
  MODIFY_MEMO: 'MODIFY_MEMO',
  ACTIVATE_MEMO: 'ACTIVATE_MEMO',
  DEACTIVATE_MEMO: 'DEACTIVATE_MEMO',
  VIEW_MEMO: 'VIEW_MEMO',
  MODIFY_PAYMENT_SCHEDULE: 'MODIFY_PAYMENT_SCHEDULE',
  PLACE_PND: 'PLACE_PND',
  UNPLACE_PND: 'UNPLACE_PND',
  PLACE_PNC: 'PLACE_PNC',
  UNPLACE_PNC: 'UNPLACE_PNC',
  FREEZE_ACCOUNT: 'FREEZE_ACCOUNT',
  UNFREEZE_ACCOUNT: 'UNFREEZE_ACCOUNT',

  VIEW_STANDING_ORDERS: 'VIEW_STANDING_ORDERS',
  MODIFY_STANDING_ORDERS: 'MODIFY_STANDING_ORDERS',
  DEACTIVATE_STANDING_ORDERS: 'DEACTIVATE_STANDING_ORDERS',
  CREATE_STANDING_ORDERS: 'CREATE_STANDING_ORDERS',
  ACTIVATE_STANDING_ORDERS: 'ACTIVATE_STANDING_ORDERS',

  // NIB PERMISSIONS
  VIEW_PROFIT: 'VIEW_PROFIT',
  MODIFY_PROFIT: 'MODIFY_PROFIT',
  CREATE_PROFIT: 'CREATE_PROFIT',
  ACTIVATE_PROFIT: 'ACTIVATE_PROFIT',
  DEACTIVATE_PROFIT: 'DEACTIVATE_PROFIT',
  CREATE_SAVING_CURRENT_PRODUCT_NIB: 'CREATE_SAVING_CURRENT_PRODUCT_NIB',
  MODIFY_SAVING_CURRENT_PRODUCT_NIB: 'MODIFY_SAVING_CURRENT_PRODUCT_NIB',
  VIEW_SAVING_CURRENT_PRODUCT_NIB: 'VIEW_SAVING_CURRENT_PRODUCT_NIB',
  ACTIVATE_SAVING_CURRENT_PRODUCT_NIB: 'ACTIVATE_SAVING_CURRENT_PRODUCT_NIB',
  DEACTIVATE_SAVING_CURRENT_PRODUCT_NIB: 'DEACTIVATE_SAVING_CURRENT_PRODUCT_NIB',
  CREATE_LOAN_PRODUCT_NIB: 'CREATE_LOAN_PRODUCT_NIB',
  MODIFY_LOAN_PRODUCT_NIB: 'MODIFY_LOAN_PRODUCT_NIB',
  VIEW_LOAN_PRODUCT_NIB: 'VIEW_LOAN_PRODUCT_NIB',
  ACTIVATE_LOAN_PRODUCT_NIB: 'VIEW_LOAN_PRODUCT_NIB',
  DEACTIVATE_LOAN_PRODUCT_NIB: 'DEACTIVATE_LOAN_PRODUCT_NIB',
  CREATE_FIXED_DEPOSIT_PRODUCT_NIB: 'CREATE_FIXED_DEPOSIT_PRODUCT_NIB',
  MODIFY_FIXED_DEPOSIT_PRODUCT_NIB: 'MODIFY_FIXED_DEPOSIT_PRODUCT_NIB',
  VIEW_FIXED_DEPOSIT_PRODUCT_NIB: 'VIEW_FIXED_DEPOSIT_PRODUCT_NIB',
  ACTIVATE_FIXED_DEPOSIT_PRODUCT_NIB: 'ACTIVATE_FIXED_DEPOSIT_PRODUCT_NIB',
  DEACTIVATE_FIXED_DEPOSIT_PRODUCT_NIB: 'DEACTIVATE_FIXED_DEPOSIT_PRODUCT_NIB',

  CREATE_SAVING_CURRENT_ACCOUNT_NIB: 'CREATE_SAVING_CURRENT_ACCOUNT_NIB',
  MODIFY_SAVING_CURRENT_ACCOUNT_NIB: 'MODIFY_SAVING_CURRENT_ACCOUNT_NIB',
  ACTIVATE_SAVING_CURRENT_ACCOUNT_NIB: 'ACTIVATE_SAVING_CURRENT_ACCOUNT_NIB',
  DEACTIVATE_SAVING_CURRENT_ACCOUNT_NIB: 'DEACTIVATE_SAVING_CURRENT_ACCOUNT_NIB',
  VIEW_SAVING_CURRENT_ACCOUNT_NIB: 'VIEW_SAVING_CURRENT_ACCOUNT_NIB',
  VIEW_CUSTOMER_ACCOUNT_BALANCE_NIB: 'VIEW_CUSTOMER_ACCOUNT_BALANCE_NIB',
  CREATE_LOAN_ACCOUNT_NIB: 'CREATE_LOAN_ACCOUNT_NIB',
  MODIFY_LOAN_ACCOUNT_NIB: 'MODIFY_LOAN_ACCOUNT_NIB',
  VIEW_LOAN_ACCOUNT_NIB: 'VIEW_LOAN_ACCOUNT_NIB',
  CREATE_FIXED_DEPOSIT_ACCOUNT_NIB: 'CREATE_FIXED_DEPOSIT_ACCOUNT_NIB',
  MODIFY_FIXED_DEPOSIT_ACCOUNT_NIB: 'MODIFY_FIXED_DEPOSIT_ACCOUNT_NIB',
  LIQUIDATE_FIXED_DEPOSIT_ACCOUNT_NIB: 'LIQUIDATE_FIXED_DEPOSIT_ACCOUNT_NIB',
  VIEW_FIXED_DEPOSIT_ACCOUNT_NIB: 'VIEW_FIXED_DEPOSIT_ACCOUNT_NIB',
  UNFREEZE_ACCOUNT_NIB: 'UNFREEZE_ACCOUNT_NIB',
  FREEZE_ACCOUNT_NIB: 'FREEZE_ACCOUNT_NIB',

}

export const adminPermissions = {
  CREATE_USER: 'CREATE_USER',
  MODIFY_USER: 'MODIFY_USER',
  ACTIVATE_USER: 'ACTIVATE_USER',
  DEACTIVATE_USER: 'DEACTIVATE_USER',
  VIEW_USER: 'VIEW_USER',
  CREATE_USER_ROLE: 'CREATE_USER_ROLE',
  MODIFY_USER_ROLE: 'MODIFY_USER_ROLE',
  ACTIVATE_USER_ROLE: 'ACTIVATE_USER_ROLE',
  DEACTIVATE_USER_ROLE: 'DEACTIVATE_USER_ROLE',
  VIEW_USER_ROLE: 'VIEW_USER_ROLE',
  RESET_PASSWORD: 'RESET_PASSWORD',
  VIEW_SYSTEM_ACCESS: 'VIEW_SYSTEM_ACCESS',
  ACTIVATE_SYSTEM_ACCESS: 'ACTIVATE_SYSTEM_ACCESS',
  DEACTIVATE_SYSTEM_ACCESS: 'DEACTIVATE_SYSTEM_ACCESS',
  DATA_HANDLING_REPORT: 'DATA_HANDLING_REPORT',
  EXPORT_DATA_HANDLING_REPORT: 'EXPORT_DATA_HANDLING_REPORT',
  VIEW_SUBSCRIPTION_CONFIG: 'VIEW_SUBSCRIPTION_CONFIG',
  VIEW_SUBSCRIPTION_INVOICE: 'VIEW_SUBSCRIPTION_INVOICE',
  VIEW_SUBSCRIPTION_HISTORY: 'VIEW_SUBSCRIPTION_HISTORY',
}

export const dashboardPermissions = {
  VIEW_EXECUTIVE_DASHBOARD: 'VIEW_EXECUTIVE_DASHBOARD',
  VIEW_BASIC_DASHBOARD: 'VIEW_BASIC_DASHBOARD',
  LANDING_PAGE: 'LANDING_PAGE',
}

export const postingPermissions = {
  CASH_DEPOSIT_POSTING: 'CASH_DEPOSIT_POSTING',
  VIEW_CASH_DEPOSIT_POSTING_LIST: 'VIEW_CASH_DEPOSIT_POSTING_LIST',
  CASH_WITHDRAWAL_POSTING: 'CASH_WITHDRAWAL_POSTING',
  VIEW_CASH_WITHDRAWAL_POSTING_LIST: 'VIEW_CASH_WITHDRAWAL_POSTING_LIST',
  LOCAL_FUNDS_TRANSFER_POSTING: 'LOCAL_FUNDS_TRANSFER_POSTING',
  VIEW_LOCAL_FUNDS_TRANSFER_POSTING: 'VIEW_LOCAL_FUNDS_TRANSFER_POSTING',
  SINGLE_JOURNAL_POSTING: 'SINGLE_JOURNAL_POSTING',
  VIEW_SINGLE_JOURNAL_POSTING: 'VIEW_SINGLE_JOURNAL_POSTING',
  BATCH_JOURNAL_POSTING: 'BATCH_JOURNAL_POSTING',
  VIEW_BATCH_JOURNAL_POSTING: 'VIEW_BATCH_JOURNAL_POSTING',
  SINGLE_JOURNAL_TO_CUSTOMER_POSTING: 'SINGLE_JOURNAL_TO_CUSTOMER_POSTING',
  VIEW_SINGLE_JOURNAL_TO_CUSTOMER_POSTING: 'VIEW_SINGLE_JOURNAL_TO_CUSTOMER_POSTING',
  BATCH_JOURNAL_TO_CUSTOMER_POSTING: 'BATCH_JOURNAL_TO_CUSTOMER_POSTING',
  VIEW_BATCH_JOURNAL_TO_CUSTOMER_POSTING: 'VIEW_BATCH_JOURNAL_TO_CUSTOMER_POSTING',
  BATCH_JOURNAL_UPLOAD_POSTING: 'BATCH_JOURNAL_UPLOAD_POSTING',
  VIEW_BATCH_JOURNAL_UPLOAD_POSTING: 'VIEW_BATCH_JOURNAL_UPLOAD_POSTING',
  BUY_CASH_POSTING: 'BUY_CASH_POSTING',
  VIEW_BUY_CASH_POSTING: 'VIEW_BUY_CASH_POSTING',
  SELL_CASH_POSTING: 'SELL_CASH_POSTING',
  VIEW_SELL_CASH_POSTING: 'VIEW_SELL_CASH_POSTING',
  REVERSAL_POSTING: 'REVERSAL_POSTING',
  VIEW_REVERSAL_POSTING: 'VIEW_REVERSAL_POSTING',
  CHEQUE_WITHDRAWAL_POSTING: 'CHEQUE_WITHDRAWAL_POSTING',
  VIEW_CHEQUE_WITHDRAWAL_POSTING: 'VIEW_CHEQUE_WITHDRAWAL_POSTING',
  LOCAL_CHEQUE_DEPOSIT_POSTING: 'LOCAL_CHEQUE_DEPOSIT_POSTING',
  VIEW_LOCAL_CHEQUE_DEPOSIT_POSTING: 'VIEW_LOCAL_CHEQUE_DEPOSIT_POSTING',
  OUTWARD_CHEQUE_DEPOSIT_POSTING: 'OUTWARD_CHEQUE_DEPOSIT_POSTING',
  VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
  TELLER_TO_TELLER_POSTING: 'TELLER_TO_TELLER_POSTING',
  VIEW_TELLER_TO_TELLER_POSTING: 'VIEW_TELLER_TO_TELLER_POSTING',
  ACCOUNT_CLOSURE_POSTING: 'ACCOUNT_CLOSURE_POSTING',
  VIEW_ACCOUNT_CLOSURE_POSTING: 'VIEW_ACCOUNT_CLOSURE_POSTING',
  BATCH_GL_CUSTOMER_POSTING: 'BATCH_GL_CUSTOMER_POSTING',
  BACKDATING_POSTING: 'BACKDATING_POSTING',
  VIEW_BACKDATING_POSTING: 'VIEW_BACKDATING_POSTING',
  BATCH_BACKDATING_POSTING: 'BATCH_BACKDATING_POSTING',
  VIEW_BATCH_BACKDATING_POSTING: 'VIEW_BATCH_BACKDATING_POSTING',
  VIEW_BATCH_GL_CUSTOMER_UPLOAD_POSTING: 'VIEW_BATCH_GL_CUSTOMER_UPLOAD_POSTING',
  END_OF_YEAR_POSTING: 'END_OF_YEAR_POSTING',
  CANCEL_POSTING: 'CANCEL_POSTING',
}

export const batchPermissions = {
  BATCH_ACCOUNT_UPLOAD: 'BATCH_ACCOUNT_UPLOAD',
  BATCH_LOAN_UPLOAD: 'BATCH_LOAN_UPLOAD',
  DATA_MIGRATION: 'DATA_MIGRATION',
  BATCH_ACCOUNT_UPDATE: 'BATCH_ACCOUNT_UPDATE',
}

export const reportPermissions = {
  GL_HISTORY_REPORT: 'GL_HISTORY_REPORT',
  FIXED_DEPOSITS_REPORT: 'FIXED_DEPOSITS_REPORT',
  EXPORT_GL_HISTORY_REPORT: 'EXPORT_GL_HISTORY_REPORT',
  EXPORT_LOANS_AND_ADVANCES_REPORT: 'EXPORT_LOANS_AND_ADVANCES_REPORT',
  DAILY_TILL_BALANCE_REPORT: 'DAILY_TILL_BALANCE_REPORT',
  EXPORT_LOAN_TRACKING_REPORT: 'EXPORT_LOAN_TRACKING_REPORT',
  LOAN_AND_ADVANCES_REPORT: 'LOAN_AND_ADVANCES_REPORT',
  ACCOUNT_BALANCE_REPORT: 'ACCOUNT_BALANCE_REPORT',
  EXPORT_ACCOUNT_BALANCE_REPORT: 'EXPORT_ACCOUNT_BALANCE_REPORT',
  LOAN_TRACKING_REPORT: 'LOAN_TRACKING_REPORT',
  EXPORT_ACCOUNT_HISTORY_REPORT: 'EXPORT_ACCOUNT_HISTORY_REPORT',
  DEPOSITS_BALANCE_REPORT: 'DEPOSITS_BALANCE_REPORT',
  EXPORT_ACCOUNT_BALANCE_MOVEMENT_REPORT: 'EXPORT_ACCOUNT_BALANCE_MOVEMENT_REPORT',
  EXPORT_FIXED_DEPOSITS_REPORT: 'EXPORT_FIXED_DEPOSITS_REPORT',
  LOAN_REPAYMENT_REPORT: 'LOAN_REPAYMENT_REPORT',
  ACCOUNT_HISTORY_REPORT: 'ACCOUNT_HISTORY_REPORT',
  EXPORT_OVERDRAFT_REPORT: 'EXPORT_OVERDRAFT_REPORT',
  EXPORT_DEPOSITS_BALANCE_REPORT: 'EXPORT_DEPOSITS_BALANCE_REPORT',
  EXPORT_LOAN_REPAYMENT_REPORT: 'EXPORT_LOAN_REPAYMENT_REPORT',
  ACCOUNT_BALANCE_MOVEMENT_REPORT: 'ACCOUNT_BALANCE_MOVEMENT_REPORT',
  EXPORT_DAILY_TILL_BALANCE_REPORT: 'EXPORT_DAILY_TILL_BALANCE_REPORT',
  OVERDRAFT_REPORT: 'OVERDRAFT_REPORT',
  VIEW_CHART_OF_ACCOUNT_REPORT: 'VIEW_CHART_OF_ACCOUNT_REPORT',
  EXPORT_CHART_OF_ACCOUNT_REPORT: 'EXPORT_CHART_OF_ACCOUNT_REPORT',
  VIEW_TRIAL_BALANCE_REPORT: 'VIEW_TRIAL_BALANCE_REPORT',
  EXPORT_TRIAL_BALANCE_REPORT: 'EXPORT_TRIAL_BALANCE_REPORT',
  VIEW_PROFIT_OR_LOSS_REPORT: 'VIEW_PROFIT_OR_LOSS_REPORT',
  EXPORT_PROFIT_OR_LOSS_REPORT: 'EXPORT_PROFIT_OR_LOSS_REPORT',
  VIEW_BALANCE_SHEET_REPORT: 'VIEW_BALANCE_SHEET_REPORT',
  EXPORT_BALANCE_SHEET_REPORT: 'EXPORT_BALANCE_SHEET_REPORT',
  GL_CLOSING_BALANCE_HISTORY_REPORT: 'GL_CLOSING_BALANCE_HISTORY_REPORT',
  CUSTOMER_CLOSING_BALANCE_HISTORY_REPORT: 'CUSTOMER_CLOSING_BALANCE_HISTORY_REPORT',
  TOTAL_DEPOSIT_LIABILITY_REPORT: 'TOTAL_DEPOSIT_LIABILITY_REPORT',
  EXPORT_TOTAL_DEPOSIT_LIABILITY_REPORT: 'EXPORT_TOTAL_DEPOSIT_LIABILITY_REPORT',
  TOTAL_OVERDRAWN_ACCOUNT_REPORT: 'TOTAL_OVERDRAWN_ACCOUNT_REPORT',
  EXPORT_OVERDRAWN_ACCOUNT_REPORT: 'EXPORT_OVERDRAWN_ACCOUNT_REPORT',
  TRANSACTION_CALLOVER_REPORT: 'TRANSACTION_CALLOVER_REPORT',
  EXPORT_TRANSACTION_CALLOVER_REPORT: 'EXPORT_TRANSACTION_CALLOVER_REPORT',
  END_OF_DAY_TRANSACTION_REPORT: 'END_OF_DAY_TRANSACTION_REPORT',
  EXPORT_END_OF_DAY_TRANSACTION_REPORT: 'EXPORT_END_OF_DAY_TRANSACTION_REPORT',
  TOTAL_DEPOSIT_TRANSACTION_REPORT: 'TOTAL_DEPOSIT_TRANSACTION_REPORT',
  EXPORT_TOTAL_DEPOSIT_TRANSACTION_REPORT: 'EXPORT_TOTAL_DEPOSIT_TRANSACTION_REPORT',
  TOTAL_CASH_WITHDRAWAL_REPORT: 'TOTAL_CASH_WITHDRAWAL_REPORT',
  EXPORT_TOTAL_CASH_WITHDRAWAL_REPORT: 'EXPORT_TOTAL_CASH_WITHDRAWAL_REPORT',
  TELLER_TILL_REPORT: 'TELLER_TILL_REPORT',
  EXPORT_TELLER_TILL_REPORT: 'EXPORT_TELLER_TILL_REPORT',
  CHECK_MY_TILL_SUMMARY: 'CHECK_MY_TILL_SUMMARY',
  LOAN_ACCRUAL_HISTORY_REPORT: 'LOAN_ACCRUAL_HISTORY_REPORT',
  SAVINGS_ACCRUAL_HISTORY_REPORT: 'SAVINGS_ACCRUAL_HISTORY_REPORT',
  FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT: 'FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT',
  EXPORT_LOAN_ACCRUAL_HISTORY_REPORT: 'EXPORT_LOAN_ACCRUAL_HISTORY_REPORT',
  EXPORT_SAVINGS_ACCRUAL_HISTORY_REPORT: 'EXPORT_SAVINGS_ACCRUAL_HISTORY_REPORT',
  EXPORT_FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT: 'EXPORT_FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT',
  OVERDRAFT_ACCRUAL_HISTORY_REPORT: 'OVERDRAFT_ACCRUAL_HISTORY_REPORT',
  EXPORT_OVERDRAFT_ACCRUAL_HISTORY_REPORT: 'EXPORT_OVERDRAFT_ACCRUAL_HISTORY_REPORT',
  ICAD_REPORT: 'ICAD_REPORT',
  EXPORT_ICAD_REPORT: 'EXPORT_ICAD_REPORT',
  EXPORT_CREDIT_BUREAU_REPORT: 'EXPORT_CREDIT_BUREAU_REPORT',
  VIEW_CLOSED_ACCOUNTS: 'VIEW_CLOSED_ACCOUNTS',
  EXPORT_CLOSED_ACCOUNTS_REPORT: 'EXPORT_CLOSED_ACCOUNTS_REPORT',
  DISBURSED_LOAN_REPORT: 'DISBURSED_LOAN_REPORT',
  EXPORT_NDIC_REPORT: 'EXPORT_NDIC_REPORT',
  VIEW_ECHANNEL_REPORT: 'VIEW_ECHANNEL_REPORT',
  EXPORT_ECHANNEL_REPORT: 'EXPORT_ECHANNEL_REPORT',
  VIEW_ACTIVE_ACCOUNTS_REPORT: 'VIEW_ACTIVE_ACCOUNTS_REPORT',
  EXPORT_ACTIVE_ACCOUNTS_REPORT: 'EXPORT_ACTIVE_ACCOUNTS_REPORT',
  EXPORT_CBN_REPORT: 'EXPORT_CBN_REPORT',
  VAT_AND_WHT_REPORT: 'VAT_AND_WHT_REPORT',
  EXPORT_VAT_AND_WHT_REPORT: 'EXPORT_VAT_AND_WHT_REPORT',
  NFIU_REPORT: 'NFIU_REPORT',
  EXPORT_NFIU_REPORT: 'EXPORT_NFIU_REPORT',
  ACCOUNT_CREATION_REPORT: 'ACCOUNT_CREATION_REPORT',
  LOAN_COLLECTIONS_REPORT: 'LOAN_COLLECTIONS_REPORT',
  EXPORT_LOAN_COLLECTIONS_REPORT: 'EXPORT_LOAN_COLLECTIONS_REPORT',
  VIEW_COMPLIANCE_REPORT: 'VIEW_COMPLIANCE_REPORT',
  EXPORT_COMPLIANCE_REPORT: 'EXPORT_COMPLIANCE_REPORT',
  VIEW_REMITA_COLLECTIONS_REPORT: 'VIEW_REMITA_COLLECTIONS_REPORT',
  EXPORT_REMITA_COLLECTIONS_REPORT: 'EXPORT_REMITA_COLLECTIONS_REPORT',
}

export const operationPermissions = {
  CREATE_BRANCH: 'CREATE_BRANCH',
  MODIFY_BRANCH: 'MODIFY_BRANCH',
  ACTIVATE_BRANCH: 'ACTIVATE_BRANCH',
  DEACTIVATE_BRANCH: 'DEACTIVATE_BRANCH',
  VIEW_BRANCH: 'VIEW_BRANCH',
  CREATE_REGION: 'CREATE_REGION',
  MODIFY_REGION: 'MODIFY_REGION',
  ACTIVATE_REGION: 'ACTIVATE_REGION',
  DEACTIVATE_REGION: 'DEACTIVATE_REGION',
  VIEW_REGION: 'VIEW_REGION',
  MODIFY_SYSTEM_SETUP: 'MODIFY_SYSTEM_SETUP',
  VIEW_SYSTEM_SETUP: 'VIEW_SYSTEM_SETUP',
  OPEN_CLOSE_BRANCH: 'OPEN_CLOSE_BRANCH',
  OPEN_CLOSE_BUSINESS: 'OPEN_CLOSE_BUSINESS',
  AUDIT_TRAIL: 'AUDIT_TRAIL',
  CREATE_APPROVAL_SETUP: 'CREATE_APPROVAL_SETUP',
  MODIFY_APPROVAL_SETUP: 'MODIFY_APPROVAL_SETUP',
  VIEW_ALL_APPROVALS: 'VIEW_ALL_APPROVALS',
  VIEW_MY_APPROVALS: 'VIEW_MY_APPROVALS',
  VIEW_PENDING_APPROVALS: 'VIEW_PENDING_APPROVALS',
  VIEW_POSTING_APPROVAL: 'VIEW_POSTING_APPROVAL',
  VIEW_APPROVAL_SETUP: 'VIEW_APPROVAL_SETUP',
  CREATE_BUSINESS_AUTOMATION: 'CREATE_BUSINESS_AUTOMATION',
  MODIFY_BUSINESS_AUTOMATION: 'MODIFY_BUSINESS_AUTOMATION',
  ACTIVATE_BUSINESS_AUTOMATION: 'ACTIVATE_BUSINESS_AUTOMATION',
  DEACTIVATE_BUSINESS_AUTOMATION: 'DEACTIVATE_BUSINESS_AUTOMATION',
  VIEW_BUSINESS_AUTOMATION: 'VIEW_BUSINESS_AUTOMATION',
  OPEN_CLOSE_BUSINESS_HISTORY: 'OPEN_CLOSE_BUSINESS_HISTORY',
  MANAGE_CLEARING_CHEQUES: 'MANAGE_CLEARING_CHEQUES',
  VIEW_COMMS_TEMPLATE: 'VIEW_COMMS_TEMPLATE',
  ADD_COMMS_TEMPLATE: 'ADD_COMMS_TEMPLATE',
  MODIFY_COMMS_TEMPLATE: 'MODIFY_COMMS_TEMPLATE',
  ACTIVATE_COMMS_TEMPLATE: 'ACTIVATE_COMMS_TEMPLATE',
  DEACTIVATE_COMMS_TEMPLATE: 'DEACTIVATE_COMMS_TEMPLATE',
  VIEW_CUSTOM_FIELD: 'VIEW_CUSTOM_FIELD',
  CREATE_CUSTOM_FIELD: 'CREATE_CUSTOM_FIELD',
  MODIFY_CUSTOM_FIELD: 'MODIFY_CUSTOM_FIELD',
  ACTIVATE_CUSTOM_FIELD: 'ACTIVATE_CUSTOM_FIELD',
  DEACTIVATE_CUSTOM_FIELD: 'DEACTIVATE_CUSTOM_FIELD',
  BULK_SMS: 'BULK_SMS',
  RECOMPUTE_EOD_BALANCE: 'RECOMPUTE_EOD_BALANCE',
  VIEW_SMS_WALLET: 'VIEW_SMS_WALLET',
  VIEW_KYC_WALLET: 'VIEW_KYC_WALLET',
  VIEW_CURRENCY: 'VIEW_CURRENCY',
  VIEW_CURRENCY_RATE: 'VIEW_CURRENCY_RATE',
  MODIFY_CURRENCY_RATE: 'MODIFY_CURRENCY_RATE',
  ADD_CURRENCY_RATE: 'ADD_CURRENCY_RATE',
  VIEW_EMAIL_REPORT: 'VIEW_EMAIL_REPORT',
  VIEW_SMS_REPORT: 'VIEW_SMS_REPORT',
}

export const eChannelsPermission = {
  CREATE_HOST_FINANCIAL_INSTITUTION: 'CREATE_HOST_FINANCIAL_INSTITUTION',
  MODIFY_HOST_FINANCIAL_INSTITUTION: 'MODIFY_HOST_FINANCIAL_INSTITUTION',
  ACTIVATE_HOST_FINANCIAL_INSTITUTION: 'ACTIVATE_HOST_FINANCIAL_INSTITUTION',
  DEACTIVATE_HOST_FINANCIAL_INSTITUTION: 'DEACTIVATE_HOST_FINANCIAL_INSTITUTION',
  VIEW_HOST_FINANCIAL_INSTITUTION: 'VIEW_HOST_FINANCIAL_INSTITUTION',
  CREATE_CARD_PROFILE: 'CREATE_CARD_PROFILE',
  MODIFY_CARD_PROFILE: 'MODIFY_CARD_PROFILE',
  ACTIVATE_CARD_PROFILE: 'ACTIVATE_CARD_PROFILE',
  DEACTIVATE_CARD_PROFILE: 'DEACTIVATE_CARD_PROFILE',
  VIEW_CARD_PROFILE: 'VIEW_CARD_PROFILE',
  REQUEST_ASSIGNED_CARDS: 'REQUEST_ASSIGNED_CARDS',
  REQUEST_UNASSIGNED_CARDS: 'REQUEST_UNASSIGNED_CARDS',
  REVOKE_CARD_REQUEST: 'REVOKE_CARD_REQUEST',
  RECEIVE_CARD_DELIVERY: 'RECEIVE_CARD_DELIVERY',
  VIEW_CARD_REQUESTS: 'VIEW_CARD_REQUESTS',
  ISSUE_ASSIGNED_CARDS: 'ISSUE_ASSIGNED_CARDS',
  ISSUE_UNASSIGNED_CARDS: 'ISSUE_UNASSIGNED_CARDS',
  MANAGE_CARDS: 'MANAGE_CARDS',
  VIEW_ISSUED_CARDS: 'VIEW_ISSUED_CARDS',
  WITHDRAW_CARD: 'WITHDRAW_CARD',
  HOTLIST_CARD: 'HOTLIST_CARD',
  BLOCK_CARD: 'BLOCK_CARD',
  UNBLOCK_CARD: 'UNBLOCK_CARD',
  VIEW_CARD_DETAILS: 'VIEW_CARD_DETAILS',
  CONFIGURE_TRANSFER_FEE: 'CONFIGURE_TRANSFER_FEE',
  SETUP_INSTITUTION: 'SETUP_INSTITUTION',
  VIEW_TRANSFER_REPORT: 'VIEW_TRANSFER_REPORT',
  INITIATE_TRANSFER: 'INITIATE_TRANSFER',
  CONFIGURE_TRANSFER_GL: 'CONFIGURE_TRANSFER_GL',
  SWITCH_TRANSFER_GATEWAY: 'SWITCH_TRANSFER_GATEWAY',
  RETRY_TRANSFER: 'RETRY_TRANSFER',
  TREAT_ACCOUNT_UPGRADE_REQUEST: 'TREAT_ACCOUNT_UPGRADE_REQUEST',
  CONFIGURE_INTERNET_BANKING: 'CONFIGURE_INTERNET_BANKING',
  VIEW_INTERNET_BANKING_USERS: 'VIEW_INTERNET_BANKING_USERS',
  UPDATE_IB_PROFILE: 'UPDATE_IB_PROFILE',
  ACTIVATE_IB_PROFILE: 'ACTIVATE_IB_PROFILE',
  DEACTIVATE_IB_PROFILE: 'DEACTIVATE_IB_PROFILE',
  CREATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG: 'CREATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
  VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG: 'VIEW_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
  DEACTIVATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG: 'DEACTIVATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
  ACTIVATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG: 'ACTIVATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
  UPDATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG: 'UPDATE_IBANKING_CUSTOMER_ONBOARDING_CONFIG',
  CREATE_THEME: 'CREATE_THEME',
  UPDATE_THEME: 'UPDATE_THEME',
  VIEW_THEME: 'VIEW_THEME',
  VIEW_ACCOUNT_UPGRADE_REQUEST: 'VIEW_ACCOUNT_UPGRADE_REQUEST',
  APPROVE_ACCOUNT_UPGRADE_REQUEST: 'APPROVE_ACCOUNT_UPGRADE_REQUEST',
  DECLINE_ACCOUNT_UPGRADE_REQUEST: 'DECLINE_ACCOUNT_UPGRADE_REQUEST',
  VIEW_SECURITY_CONFIG: 'VIEW_SECURITY_CONFIG',
  UPDATE_SECURITY_CONFIG: 'UPDATE_SECURITY_CONFIG',
  ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER: 'ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER',
  ENABLE_DISABLE_MOBILE_AND_INTERNETBANKING_TRANSFERS: 'ENABLE_DISABLE_MOBILE_AND_INTERNETBANKING_TRANSFERS',
  VIEW_INTERBANK_TRANSFER_CONFIGURATION: 'VIEW_INTERBANK_TRANSFER_CONFIGURATION',
  VIEW_CARD_REQUEST_LOG: 'VIEW_CARD_REQUEST_LOG',
  EXPORT_CARD_REQUEST_LOG: 'EXPORT_CARD_REQUEST_LOG',
  VIEW_INWARD_TRANSFER_REPORT: 'VIEW_INWARD_TRANSFER_REPORT',
  VIEW_BILLS_PAYMENT_HISTORY: 'VIEW_BILLS_PAYMENT_HISTORY',
  MAKE_BILLS_PAYMENT: 'MAKE_BILLS_PAYMENT',
  ADD_BILLS_PAYMENT_CONFIG: 'ADD_BILLS_PAYMENT_CONFIG',
  UPDATE_CARD_LIMIT: 'UPDATE_CARD_LIMIT',
  VIEW_REGULATORY_LIMIT: 'VIEW_REGULATORY_LIMIT',
  VIEW_CARD_LIMIT: 'VIEW_CARD_LIMIT',
  UPDATE_ACCOUNT_LIMIT: 'UPDATE_ACCOUNT_LIMIT',
  CREATE_CARD_LIMIT: 'CREATE_CARD_LIMIT',
  VIEW_ACCOUNT_LIMIT: 'VIEW_ACCOUNT_LIMIT',
  UPDATE_INSTITUTION_LIMIT: 'UPDATE_INSTITUTION_LIMIT',
  CREATE_ACCOUNT_LIMIT: 'CREATE_ACCOUNT_LIMIT',
  VIEW_INSTITUTION_LIMIT: 'VIEW_INSTITUTION_LIMIT',
  CREATE_INSTITUTION_LIMIT: 'CREATE_INSTITUTION_LIMIT',
  VIEW_BILLS_WALLET: 'VIEW_BILLS_WALLET',
  WEBHOOK_NOTIFICATION_REPORT: 'WEBHOOK_NOTIFICATION_REPORT',
  CREATE_API_CLIENT: 'CREATE_API_CLIENT',
  UPDATE_API_CLIENT: 'UPDATE_API_CLIENT',
  SEARCH_API_CLIENTS: 'SEARCH_API_CLIENTS',
  REGENERATE_API_CLIENT_SECRET: 'REGENERATE_API_CLIENT_SECRET',
  ACTIVATE_API_CLIENT: 'ACTIVATE_API_CLIENT',
  DEACTIVATE_API_CLIENT: 'DEACTIVATE_API_CLIENT',
  ACTIVATE_CARD: 'ACTIVATE_CARD',
  LINK_INSTANT_CARD: 'LINK_INSTANT_CARD',
  UNLINK_INSTANT_CARD: 'UNLINK_INSTANT_CARD',

}

export const fraudMonitorPermissions = {
  VIEW_BLACKLIST: 'VIEW_BLACKLIST',
  ADD_BLACKLIST: 'ADD_BLACKLIST',
  REMOVE_BLACKLIST: 'REMOVE_BLACKLIST',
  VIEW_WHITELIST: 'VIEW_WHITELIST',
  ADD_WHITELIST: 'ADD_WHITELIST',
  REMOVE_WHITELIST: 'REMOVE_WHITELIST',
  ACTIVATE_TRANSACTION_RULE: 'ACTIVATE_TRANSACTION_RULE',
  DEACTIVATE_TRANSACTION_RULE: 'DEACTIVATE_TRANSACTION_RULE',
  CREATE_TRANSACTION_RULE: 'CREATE_TRANSACTION_RULE',
  MODIFY_TRANSACTION_RULE: 'MODIFY_TRANSACTION_RULE',
  VIEW_TRANSACTION_RULE: 'VIEW_TRANSACTION_RULE',
  VIEW_SUSPICIOUS_TRANSACTION_REPORT: 'VIEW_SUSPICIOUS_TRANSACTION_REPORT',
  CLOSE_SUSPICIOUS_TRANSACTION_CASE: 'CLOSE_SUSPICIOUS_TRANSACTION_CASE',
  REOPEN_SUSPICIOUS_TRANSACTION_CASE: 'REOPEN_SUSPICIOUS_TRANSACTION_CASE',
  ADD_SANCTIONED_ID: 'ADD_SANCTIONED_ID',
  VIEW_SANCTIONED_LIST: 'VIEW_SANCTIONED_LIST',

}

export const lmsPermissions = {
  MODIFY_PFI_ONBOARDING: 'MODIFY_PFI_ONBOARDING',
  VIEW_PFI_ONBOARDING: 'VIEW_PFI_ONBOARDING',
  ADD_PFI_ONBOARDING: 'ADD_PFI_ONBOARDING',
  VIEW_END_BENEFICIARY: 'VIEW_END_BENEFICIARY',
  MODIFY_END_BENEFICIARY_UPLOAD: 'MODIFY_END_BENEFICIARY_UPLOAD',
  BATCH_END_BENEFICIARY_UPLOAD: 'BATCH_END_BENEFICIARY_UPLOAD',
  EXPORT_PFI_ONBOARDING: 'EXPORT_PFI_ONBOARDING',
  VIEW_DUE_DILIGENCE: 'VIEW_DUE_DILIGENCE',
  SUBMIT_DUE_DILIGENCE: 'SUBMIT_DUE_DILIGENCE',
  EXPORT_COLLATERAL_INFORMATION: 'EXPORT_COLLATERAL_INFORMATION',
  VIEW_COLLATERAL_INFORMATION: 'VIEW_COLLATERAL_INFORMATION',
  MODIFY_COLLATERAL_INFORMATION: 'MODIFY_COLLATERAL_INFORMATION',
  ACTIVATE_COLLATERAL_INFORMATION: 'ACTIVATE_COLLATERAL_INFORMATION',
  DEACTIVATE_COLLATERAL_INFORMATION: 'DEACTIVATE_COLLATERAL_INFORMATION',
  ADD_COLLATERAL_INFORMATION: 'ADD_COLLATERAL_INFORMATION',
  ADD_EXTERNAL_LOAN_ACCOUNT: 'ADD_EXTERNAL_LOAN_ACCOUNT',
  MODIFY_EXTERNAL_LOAN_ACCOUNT: 'MODIFY_EXTERNAL_LOAN_ACCOUNT',
  VIEW_EXTERNAL_LOAN_ACCOUNT: 'VIEW_EXTERNAL_LOAN_ACCOUNT',

  SETUP_CREDIT_LIMIT: 'SETUP_CREDIT_LIMIT',
  SUBMIT_DIRECTORS_KYC: 'SUBMIT_DIRECTORS_KYC',
  UPLOAD_MFA_DOCUMENT: 'UPLOAD_MFA_DOCUMENT',
  ADD_DUE_DILIGENCE_REVIEW: 'ADD_DUE_DILIGENCE_REVIEW',
}
